import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import "../../../styles/pages/seo/SEO.css";
import SEOHeader from "./SEOHeader";
import SEOFacts from "./SEOFacts";
import SEOUX from "./SEOUX";
import SEOSocial from "./SEOSocial";
import Footer from "../../footer/Footer";
import onScrollHandler from "../../../utilities/onScrollHandler";
import NextPrompt from "../../nextprompt/NextPrompt";

export default class SEO extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="SEO page-wrapper">
        <NavMenu />

        <SEOHeader />
        <SEOFacts />
        <SEOUX />
        <SEOSocial />

        <NextPrompt />
        <Footer page={"seo"} />
      </div>
    );
  }
}
